var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.$store.getters['resource/currentResource'].key,staticClass:"white-container"},[_c('EmailView',{attrs:{"fields":_vm.fields,"editing":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }